module.exports = __webpack_public_path__ + "static/img/supplierLogo.5c1c4c43.svg";